import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { abstractMembershipOptions } from '@/module/Nomen/AbstractMembership/model/AbstractMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type AbstractMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function AbstractMembershipSelectControl<T extends FieldValues>(props: AbstractMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(abstractMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
